import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Card, CardHeader, CardBody, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Row, Col } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { H3, Btn, Breadcrumbs, H4 } from '../../../AbstractElements';
import { Link, useNavigate } from 'react-router-dom';
import { getClientUrlDataToken, postClientUrlWithToken } from '../../../Utils/restUtils';
import { Add, Customer, CustomerList, Search, Filter, Area, Status, Export, ArchiveCustomer, ArchiveCustomerLists } from '../../../Constant';
import { viewCustomer, viewCustomerRole, getArea, getAreaRole, viewArchiveCustomer, viewArchiveCustomerRole, changecutomerstatus, changecutomerstatusRole } from '../../../CommonUrl';
import { useSelector } from 'react-redux';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import DatePicker from 'react-datepicker';
import { conditionalRow } from '../../Common/Rowstyle/Rowstyle';
import moment from 'moment';
import { toast } from 'react-toastify';
import SweetAlert from 'sweetalert2';
import Transparentspinner from '../../Common/Loader/Transparentspinner';

const ArchiveCustomerList = () => {
    const [spinnerTrans, setspinnerTrans] = useState(false);
    const navigate = useNavigate();
    const authState = useSelector((state) => state.auth);
    const toggleStyle = { padding: '10px 20px', opacity: '0.8', fontSize: '14px' }
    const [customerLists, setCustomerList] = useState([]);
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const isSearched = useRef(null);
    const isArea = useRef(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
    const [filters, setFilters] = useState({
        searchKey: '',
        areaFilter: '',
    });
    const [sortConfig, setSortConfig] = useState({ column: '', order: '' });

    const CustomerColumns = [
        {
            name: <H4>Sl</H4>,
            selector: row => row.Si,
            width: '70px'
        },
        {
            name: <i className="fa fa-gears" style={{ fontSize: '15px' }}></i>,
            selector: row => row.action,
            cell: row => <ActionCell row={row} />,
            center: true,
            width: '60px'
        },
        {
            name: <H4>Customer Id</H4>,
            id: 'subscriber_id',
            selector: row => row.subscriber_id,
            sortable: true,
            wrap: true,
            cell: row => (authState.userRole === 1 || authState.permissions.includes('show-customer-profile')) ?
                <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/customers/customer/userProfile?id=${row.id}`}>
                    {row.subscriber_id}
                </Link> : row.subscriber_id,
        },
        {
            name: <H4>Name</H4>,
            id: 'name',
            selector: row => row.name,
            sortable: true,
            wrap: true
        },
        {
            name: <H4>Status</H4>,
            selector: row => row.Date,
            cell: row => (
                <span
                    className={`badge badge-${row.Status}`}
                >
                    {row.Status}
                </span>
            ),
        },
        {
            name: <H4>Mobile No</H4>,
            selector: row => row.Mobile,
            id: 'mobile',
            sortable: true,
        },
        {
            name: <H4>Address</H4>,
            selector: row => row.Address,
            id: 'address',
            sortable: true,
            wrap: true,
        },
        {
            name: <H4>Unpaid Amount</H4>,
            selector: row => row.Route,
            id: 'unpaid_amount',
            sortable: true,
            center: true,
            wrap: true,
        },
    ];

    useEffect(() => {
        fetchCustomer(1);
    }, []);

    const handleApiError = (status) => {
        if (status >= 400 && status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (status >= 500 && status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };

    const handleSort = (column) => {
        let newOrder = 'asc';
        if (sortConfig.column === column.id) {
            newOrder = sortConfig.order === 'asc' ? 'desc' : 'asc';
        }
        setSortConfig({ column: column.id, order: newOrder });
        fetchCustomer(currentPage, perPage, filters.searchKey, filters.areaFilter, column.id, newOrder);
    };


    const fetchCustomer = async (page, size = perPage, searchKey = '', areaFilter = '', sortBy = '', sortOrder = '') => {
        setspinnerTrans(true)
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ? viewArchiveCustomer +
            `?page=${page}&page_length=${size}&search=${searchKey}&area_id=${areaFilter}&sort_by=${sortBy}&sort_order=${sortOrder}` :
            viewArchiveCustomerRole + `?page=${page}&page_length=${size}&search=${searchKey}&area_id=${areaFilter}&sort_by=${sortBy}&sort_order=${sortOrder}`);
        if (response.status === true) {
            setResetPaginationToggle(!resetPaginationToggle);
            const SerialNo = (page - 1) * size + 1;
            setCustomerList(response.data.data.map((e, index) => {
                return {
                    Si: SerialNo + index,
                    subscriber_id: <span>{e.subscriber_id}</span>,
                    name: e.name,
                    Mobile: "+" + e.country_code + " " + e.mobile,
                    Address: e.address.replace(/"/g, "" || ""),
                    Route: `${authState.currency} ${e.unpaid_amount}`,
                    Type: e.customer_type,
                    Date: e.join_date,
                    id: e.id,
                    Status: e.status
                }
            }))
            setTotalRows(response.data.total);
        } else {
            handleApiError(response.status);
        }
        setspinnerTrans(false)
    };



    const ActionCell = ({ row }) => {
        const [dropdownOpen, setDropdownOpen] = React.useState(false);
        const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

        const handlePaymentClick = () => {
            SweetAlert.fire({
                title: 'Confirm restore?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ok',
                cancelButtonText: 'cancel',
                reverseButtons: true
            }).then(async (result) => {
                setspinnerTrans(true);
                if (result.value) {
                    const orderIdRes = { customer_id: row.id, status: 'active' }
                    const restoreApi = await postClientUrlWithToken(authState.apiUrl, authState.userRole === 1 ? changecutomerstatus : changecutomerstatusRole, orderIdRes);
                    if (restoreApi.status === 200) {
                        if (restoreApi.data.status === true) {
                            SweetAlert.fire(
                                'Restored!',
                                'Your file has been restored.',
                                'success'
                            );
                            fetchCustomer(currentPage, perPage, filters.searchKey, filters.areaFilter, sortConfig.column, sortConfig.order);
                        } else {
                            setspinnerTrans(false)
                            toast.error(restoreApi.data.message);
                        }
                    } else {
                        handleApiError(restoreApi.status);
                    }
                }
                setspinnerTrans(false);
            });
        };

        return (
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle color="#00000" style={{ fontSize: '14px', zIndex: 1000 }}>
                    <i className="fa fa-ellipsis-v"></i>
                </DropdownToggle>
                <DropdownMenu container="body">
                    <DropdownItem style={{ padding: '10px 20px', color: 'red', opacity: '0.8', fontSize: '14px' }} onClick={() => handlePaymentClick()}>Restore</DropdownItem>
                </DropdownMenu>
            </Dropdown>
        );
    };


    const exportCustomerExcel = async () => {
        setspinnerTrans(true)
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ?
            viewArchiveCustomer + `?export=customer_data&search=${filters?.searchKey ? filters.searchKey : ''}
            &sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`
            : viewArchiveCustomerRole + `?export=customer_data&search=${filters?.searchKey ? filters.searchKey : ''}
            &sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`);
        const dataToExport = response.data.data.map(({ subscriber_id, name, status, mobile, address, unpaid_amount, country_code }) => ({ Customer_Id: subscriber_id, Name: name, Status: status, Mobile: `+${country_code} ${mobile}`, Address: address.replace(/"/g, ''), Unpaid_Amount: unpaid_amount }));
        if (response.status === true) {
            const ws = XLSX.utils.json_to_sheet(dataToExport);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Customer Data');
            XLSX.writeFile(wb, 'customer_archive_data.xlsx');
        } else {
            handleApiError(response.status);
        }
        setspinnerTrans(false)
    };

    const exportCustomerPdf = async () => {
        setspinnerTrans(true)
        const response = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ?
            viewArchiveCustomer + `?export=customer_data&search=${filters?.searchKey ? filters.searchKey : ''}
            &sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`
            : viewArchiveCustomerRole + `?export=customer_data&search=${filters?.searchKey ? filters.searchKey : ''}
            &sort_by=${sortConfig.column}&sort_order=${sortConfig.order}`);
        const dataToExport = response.data.data.map(({ subscriber_id, name, status, mobile, address, unpaid_amount, country_code }, index) => ({ Sl: index + 1, subscriber_id, name, status, mobile: `+${country_code} ${mobile}`, address, unpaid_amount }));
        if (response.status === true) {
            const doc = new jsPDF();
            const heading = "Customer's list";
            doc.setFontSize(18);
            doc.setFont("helvetica", "bold");
            doc.text(heading, 14, 22);

            const columns = ["Sl", "Customer Id", "Name", "Status", "Mobile", "Address", "Unpaid Amount"];
            const rows = dataToExport.map(({ subscriber_id, name, status, mobile, address, unpaid_amount }, index) => [index + 1, subscriber_id, name, status, mobile, address, unpaid_amount]);
            doc.autoTable({
                head: [columns],
                body: rows,
                startY: 27
            });
            doc.save("customer_archive_data.pdf");
        } else {
            handleApiError(response.status);
        }
        setspinnerTrans(false)
    };


    const handlePageChange = page => {
        fetchCustomer(page, perPage, filters.searchKey, sortConfig.column, sortConfig.order);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        fetchCustomer(page, newPerPage, filters.searchKey, sortConfig.column, sortConfig.order);
        setPerPage(newPerPage);
    };

    const handleFilter = async (e) => {
        e.preventDefault();
        const searchKey = isSearched.current.value;
        setFilters({
            searchKey,
        });
        fetchCustomer(currentPage, perPage, searchKey, sortConfig.column, sortConfig.order);
    };


    return (
        <Fragment>
            {spinnerTrans && <Transparentspinner />}
            <Breadcrumbs mainTitle={ArchiveCustomer} parent="Customers" title={ArchiveCustomer} />
            <Card className='cardWidth'>
                <CardHeader style={{ margin: '-25px 0 -40px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <H3>{ArchiveCustomerLists}</H3>
                    <div style={{ display: 'flex' }}>
                        <CardBody className="dropdown-basic" style={{ borderRadius: '5px' }}>
                            <Dropdown className='ms-2' isOpen={dropdownOpen} toggle={toggleDropdown}>
                                <DropdownToggle color="#fff" style={{ fontSize: '14px', zIndex: 1000 }} className="btn btn-primary mr-4">
                                    {Export} <i className="icofont icofont-arrow-up"></i>
                                </DropdownToggle>
                                <DropdownMenu container="body">
                                    <DropdownItem style={toggleStyle} onClick={() => exportCustomerExcel()}><i className="fa fa-file-excel-o me-2"></i> Excel</DropdownItem>
                                    <DropdownItem style={toggleStyle} onClick={() => exportCustomerPdf()}><i className="fa fa-file-pdf-o me-2"></i> Pdf</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </CardBody>
                    </div>
                </CardHeader>
                <CardBody>
                    <span className=''>
                        <Form className="needs-validation" noValidate onSubmit={handleFilter}>
                            <Row className="ps-3 gap-sm-3 gap-md-2 mb-4 filterGap">
                                <Col sm="12" md='5' lg='2'>
                                    <input className="form-control" placeholder={Search} type="text" ref={isSearched}
                                    />
                                </Col>
                                <Col sm="12" md="5" lg='1' className="custom-filtrs">
                                    <Btn attrBtn={{ color: "primary" }} type="submit">{Filter}</Btn>
                                </Col>
                            </Row>
                        </Form>
                    </span>

                    <div className="order-history table-responsive">
                        <DataTable
                            columns={CustomerColumns}
                            data={customerLists}
                            // progressPending={loading}
                            pagination
                            paginationServer
                            defaultSortAsc
                            onSort={handleSort} // Attach sorting handler here
                            sortServer // Enable server-side sorting
                            paginationRowsPerPageOptions={[10, 25, 50, 100]}
                            paginationTotalRows={totalRows}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            conditionalRowStyles={conditionalRow}
                            onChangePage={handlePageChange}
                            fixedHeader
                        />
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default ArchiveCustomerList;